if (!customElements.get("fixed-product-form")) {
  class FixedProductForm extends HTMLElement {
    constructor() {
      super();
      const intersector = document.querySelector("[data-hide-bottom-overlay]");

      this.initStickyBottomOverlay(this, intersector);
    }

    initStickyBottomOverlay(stickyEl, intersector) {
      if (stickyEl && intersector) {

        const handler = (entries) => {
          if (entries[0].boundingClientRect.top < 0) {
            stickyEl.setAttribute("open", "");
          } else {
            stickyEl.removeAttribute("open");
          }
        }

        const observer = new IntersectionObserver(handler, {
          threshold: 0.9
        });

        observer.observe(intersector);
      }
    }
  }

  customElements.define('fixed-product-form', FixedProductForm);
}
